import { LimitsController } from './LimitsController';
import { BatchController } from "./BatchController";
import { CalendarController } from "./CalendarController";
import { CamnundaController } from "./CamundaController";
import { KassaController } from './KassaController';
import { CurrencyController } from './CurrencyController';
import { FileController } from "./FileController";
import { DepartmentCotroller } from './DepartmentCotroller';
import { HistoryController } from "./HistoryController";
import { QueryController } from "./QueryController";
import { ReportController } from "./ReportController";
import { SlaController } from "./SlaController";
import { ParsingController } from './ParsingController';
import { RateController } from './RateController';
import { LogsController } from './LogsController';
import { RequestController } from './RequestController';
import { DocumentsCotroller } from './DocumentsController';
import { ClientController } from './ClientController';
import { OtpController } from './OtpController';
import { BlackListCoontroller } from './BlackList';
import { HistoryRequestController } from './HistoryRequestController';
import { CashManagementController } from './CashManagementController';
import { HelpdeskController } from "./HelpdeskController";
import { QrAuthController } from './QrAuth';
import { PrinterAgentController } from './PrinterController';
import { WebPushController } from "./WebPushController";
import { AcceptController } from "./AcceptController";
import { PkbController } from './PkbController';
import { EmployeeController } from './EmployeeController';
import { CashController } from './CashController';
import { AuditController } from './AuditController';



export class Api {
    camunda = new CamnundaController();
    file = new FileController();
    calendar = new CalendarController();
    sla = new SlaController();
    history = new HistoryController();
    batch = new BatchController();
    report = new ReportController();
    query = new QueryController();

    department = new DepartmentCotroller();
    currency = new CurrencyController();
    kassa = new KassaController();
    parsing = new ParsingController();
    rate = new RateController();
    logs = new LogsController();
    request = new RequestController();
    documents = new DocumentsCotroller();
    client = new ClientController();
    otp = new OtpController();
    blackList = new BlackListCoontroller();
    historyReqyest = new HistoryRequestController();
    cashManagement = new CashManagementController();
    helpdesk = new HelpdeskController();
    qrAuth = new QrAuthController();
    printerAgent = new PrinterAgentController();
    webPush = new WebPushController();
    accept = new AcceptController();
    pkb = new PkbController();
    employee = new EmployeeController();
    limits = new LimitsController();
    cash = new CashController();
    audit = new AuditController();
}

export const api = new Api();
